export const reviewArrayFieldStyles = {
	nestedGroup: {
		mt: 1,
		p: 2,
		backgroundColor: 'grey.50',
		borderRadius: 1,
		border: '1px solid',
		borderColor: 'divider',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: 2
	},

	nestedGroupTitle: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '1rem',
		color: 'text.primary',
		fontWeight: 700
	},

	rowContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	validCardsContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	},

	individualRemovedCardContainer: {
		display: 'flex',
		width: '100%'
	},

	validRowsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	}
};
